// extracted by mini-css-extract-plugin
module.exports = {"Container":"Page_Container__6KQgM","LeftCol":"Page_LeftCol__e4NHL"};